var render = function (_h,_vm) {var _c=_vm._c;return _c('b-row',[_c('b-col',{attrs:{"md":"4"}},[_c('label',{staticClass:"labels"},[_vm._v(_vm._s(_vm.props.title))])]),_c('b-col',{attrs:{"md":"8"}},[_c('p',{staticClass:"label-detail"},[_vm._t("default")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }